import { render, staticRenderFns } from "./BoutonAjoutIncident.vue?vue&type=template&id=4cbbc4ba&"
import script from "./BoutonAjoutIncident.vue?vue&type=script&lang=js&"
export * from "./BoutonAjoutIncident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports